import React from 'react';
import PageSidebar from '../Pages/PageSidebar';
import './PagesColumn.scss';

/**
 * Pages Column for ExpandableColumn
 * Shows the PageSidebar with all page navigation
 */
const PagesColumn = () => {
  return (
    <div className="pages-column">
      <PageSidebar />
    </div>
  );
};

export default PagesColumn;

